import slice from './reducer'
import caseSaga from './saga'

export const {
  fetchCaseRequest,
  fetchCaseSuccess,
  fetchCaseError,
  fetchCaseSilent,

  caseReset,

  updateLastUpdated,
  handleUploadTookTooLong,
  updateCaseFailedDueToConflict,
} = slice.actions

export default slice.reducer
export { caseSaga }
